import type { UploadState } from '@/features/mcap/types/upload';

export const INITIAL_UPLOAD_STATE: UploadState = {
  phase: 'idle',
  totalBytes: 0n,
  completedBytes: 0n,
  hashProgress: 0,
};
